import { createTheme, responsiveFontSizes } from '@mui/material/styles';

/**
 * このアプリの角丸トークン。入力欄・ボタン（GameButton の warning）と同じ値で、
 * 面を持つ部品はここに揃える。
 *
 * プレイヤータイルだけは 15px と意図的に丸くしてある（映像を柔らかく見せるため）。
 * タイルに合わせるとダイアログが丸すぎたので、ダイアログはこちらを使う。
 */
export const BORDER_RADIUS = 8;

const baseTheme = createTheme({
  typography: {
    fontFamily: '"Noto Sans JP", sans-serif',
    h3: { fontSize: '3rem', fontWeight: 500 }, // 48px タイマー
    body1: { fontSize: '1rem' }, // 16px 日目・アラートタイトル
    body2: { fontSize: '0.875rem' }, // 14px サブテキスト
    caption: { fontSize: '0.75rem' }, // 12px 小ラベル・ログ
  },
  palette: {
    primary: {
      main: '#4d5e76',
      light: '#5d6e86',
      dark: '#3d4e62',
      contrastText: '#ffffff',
    },
    text: {
      secondary: 'rgba(0, 0, 0, 0.5)',
    },
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: BORDER_RADIUS,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          // MUI 既定の 4px だと角が立って見えるので、アプリの角丸トークンに揃える
          borderRadius: BORDER_RADIUS,
        },
      },
    },
  },
});

export const theme = responsiveFontSizes(baseTheme);
